import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const EmployeeModulesGridWidget: WidgetRegistryEntry = {
  name: "EmployeeModulesGrid",
  component: () => import("./employee-modules-grid-widget.component").then((m) => m.EmployeeModulesGridWidgetComponent),
  configuration: {
    templateName: "Mitarbeiter Module"
  }
};
